import { Component, OnInit } from '@angular/core';
import { async } from '@angular/core/testing';
import { ApiService } from '../../../services/api.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
declare var require: any
const FileSaver = require('file-saver');
import { FormGroup, FormControl, Validators } from '@angular/forms';
declare var $: any;
import { DatePipe } from '@angular/common'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-meeting-minutes',
  templateUrl: './meeting-minutes.component.html',
  styleUrls: ['./meeting-minutes.component.css']
})
export class MeetingMinutesComponent implements OnInit {

  page_view = false
  name_province: any
  list_report: any = []
  pdfSrc: any
  public loading = false;
  pdf_detail: any
  page = 1;
  count = 0;
  tableSize = 15;

  reportM_form = new FormGroup({
    rpm_session: new FormControl('', [Validators.required]),
    rpm_name: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    time: new FormControl('', [Validators.required]),
    id: new FormControl('')
  });
  
  constructor(
    private _location: Location,
    private services: ApiService,
    public router: Router,
    private ActivatedRoute: ActivatedRoute,
  ) {
    
  }

  ngOnInit(): void {
    document.getElementById('meeting-c')!.classList.toggle("active");
    this.getAllReport();
  }
  ngOnDestroy(){
    if(document.getElementById('meeting-c')){
      document.getElementById('meeting-c')!.classList.remove("active");
    }
  }

  async getAllReport(){
    await this.services.get('report_meeting').then((res: any) => {
      res.forEach((e:any) => {
        e.dateNum = this.convertDate(e.date)
      });
      this.list_report = res.sort((a: any, b: any) => (new Date(a.dateNum) > new Date(b.dateNum)) ? -1 : ((new Date(b.dateNum) > new Date(a.dateNum)) ? 1 : 0))
    });
  }

  async view_pdf(data:any) {
    this.loading = true;
    this.page_view = true
    this.pdf_detail = data
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/report_committee/" + data.pdf_name
  }
  download_pdf(item:any){
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/report_committee/" + item.pdf_name;
    FileSaver.saveAs(this.pdfSrc, item.rpm_name);
  }

  close_pdf() {
    this.loading = false;
    this.page_view = false
  }
  backClicked() {
    this._location.back();
  }

  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  convertDate(date:any){
    let data = date.split([' ']);
    let day = data[0]
    let month: any
    let year = Number(data[2])-543
    switch (data[1]) {
      case 'มกราคม': {
        month = 1
        break;
      }
      case 'กุมภาพันธ์': {
        month = 2
        break;
      }
      case 'มีนาคม': {
        month = 3
        break;
      }
      case 'เมษายน': {
        month = 4
        break;
      }
      case 'พฤษภาคม': {
        month = 5
        break;
      }
      case 'มิถุนายน': {
        month = 6
        break;
      }
      case 'กรกฎาคม': {
        month = 7
        break;
      }
      case 'สิงหาคม': {
        month = 8
        break;
      }
      case 'กันยายน': {
        month = 9
        break;
      }
      case 'ตุลาคม': {
        month = 10
        break;
      }
      case 'พฤศจิกายน': {
        month = 11
        break;
      }
      case 'ธันวาคม': {
        month = 12
        break;
      }
      default: {
        //statements; 
        break;
      }
    }

    return `${year}-${month}-${day}`
  }

  onClick(data:any){
    this.reportM_form.patchValue({
      rpm_session: data.rpm_session,
      rpm_name: data.rpm_name,
      date: new DatePipe('en-US').transform(new Date(new Date(data.dateNum).getFullYear(), new Date(data.dateNum).getMonth(), new Date(data.dateNum).getDate()), 'yyyy-MM-dd'),
      time: data.time,
      id: data.id
    });
  }

  onUpdate(){
    this.reportM_form.patchValue({
      date: this.dateThai(this.reportM_form.value.date)
    })
    this.services.update('report_meeting', Number(this.reportM_form.value.id), this.reportM_form.value).then((res:any)=>{
      $("#reportMeeting_update").modal('hide');
      this.getAllReport()
      Swal.fire({
        title: 'แก้ไขสำเร็จ',
        icon: 'success',
        confirmButtonText: `ตกลง`
      })
    })

  }

  dateThai(date: any) {
    var newDate = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return newDate;
  }
}
